//import styles from './App.module.css';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import Doctors from './pages/Doctors/Doctors';
import AllTests from './pages/AllTests';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import MyPatients from './pages/MyPatients/MyPatients';
import MyTests from './pages/MyTests/MyTests';
import Profile from './pages/Profile';
import Reports from './pages/Reports/Reports';
import axios from './util/Axios';
import * as actions from './store/actions/GlobalActions';
import { useDispatch } from 'react-redux';
import { ArmsChartsPage } from './pages/ArmsCharts/ArmsChartsPage';
import { DataSetPage } from './pages/Datasets/DataSetPage';
import ValidTests from './pages/ValidTests';
import TestsForReview from './pages/TestsForReview';
import { Invitations } from './pages/Invitations/Invitations';
import { AcceptInvitation } from './pages/UserRegistration/00-AcceptInvitation';
import { ThermsAndConditions } from './pages/UserRegistration/04-ThermsAndConditions';
import InformedConsents from './pages/InformedConsents/InformedConsents';
import { LegalDocumentsBg } from './pages/LegalDocumentsBg';
import { TestDetailsPage } from './pages/TestDetailsPage';
import { BeginPasswordReset } from './pages/PasswordReset/00-BeginPasswordReset';
import { TestReviewPage } from './pages/Ems/TestReviewPage';
import { ThemeProvider, Modal, Paper, Typography, Button } from '@mui/material';
import ValidateMFA from './pages/ValidateMFA';
import theme from './theme/Theme';
import Hospitals from './pages/Hospitals/Hospitals';
import DeletedTests from './components/DeletedTests';
import RestrictedRoute from './components/RestrictedRoute';
import ForgotPassword from './pages/PasswordReset/ForgotPassword';
import useInactivityTimeout from './hooks/useInactivityTimeout';

function App() {
  const [openInactivityModal, setOpenInactivityModal] = useState(false);

  const logged = useSelector((state) => state.GlobalReducer.logged);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () => {
    let authToken = window.localStorage.getItem('auth');
    if (!authToken) return;

    axios.post('/users/logout').then(() => {
      localStorage.clear();
      dispatch({ type: actions.LOGOUT });
      setOpenInactivityModal(true);
      navigate('/login', { replace: true });
    });
  };

  useInactivityTimeout({ onIdle: logout });

  if (logged) {
    axios.get('/applicationInit').then((data) => {
      dispatch({
        type: actions.LOGIN,
        payload: { user: data.data.user, auth: data.data.authToken },
      });
    });
  }

  const handleCloseInactivityModal = () => {
    setOpenInactivityModal(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="forgotpass" element={<ForgotPassword />} />
        <Route path="mfa" element={<ValidateMFA />} />
        <Route path="invitations/:token" element={<AcceptInvitation />} />
        <Route path="resetPassword/:token" element={<BeginPasswordReset />} />
        <Route path="armsCharts/:testId" element={<ArmsChartsPage />} />
        <Route path="fastaiEms/:testId" element={<TestReviewPage />} />
        <Route path="thermsAndConditions" element={<ThermsAndConditions />} />
        <Route path="agreements" element={<LegalDocumentsBg />} />
        <Route path="" element={logged ? <Dashboard /> : <Navigate to="login" />}>
          <Route element={<RestrictedRoute roles={['PATIENT']} />} >
            <Route path="myTests" element={<MyTests />} />
            <Route path="myTests/:doctorId" element={<MyTests />} />
          </Route>
          <Route element={<RestrictedRoute roles={['DOCTOR']} />} >
            <Route path="profile" element={<Profile />} />
            <Route path="patients" element={<MyPatients />} />
          </Route>
          <Route element={<RestrictedRoute roles={['LEGAL_TEAM', 'ADMIN']} />} >
            <Route path="informedConsents" element={<InformedConsents />} />
          </Route>
          <Route element={<RestrictedRoute roles={['ADMIN']} />} >
            <Route path="doctors" element={<Doctors />} />
            <Route path="hospitals" element={<Hospitals />} />
            <Route path="invitations" element={<Invitations />} />
            <Route path="reports" element={<Reports />} />
            <Route path="/deletedTests" element={<DeletedTests />} />
            <Route path="all" element={<AllTests />} />
            <Route path="forReview" element={<TestsForReview title={'Tests for review'} />} />
            <Route path="forValidityReview" element={<TestsForReview title={'Tests for Validity Review'} />} />
            <Route path="forMedicalReview" element={<TestsForReview title={'Tests for Medical Review'} />} />
            <Route path="validFace" element={<ValidTests />} />
            <Route path="validSpeech" element={<ValidTests />} />
            <Route path="validArms" element={<ValidTests />} />
            <Route path="dataSets/:dataSetId" element={<DataSetPage />} />
            <Route path="testDetails/:testId" element={<TestDetailsPage />} />
          </Route>
        </Route>
      </Routes>
      <Modal
        open={openInactivityModal}
        onClose={handleCloseInactivityModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          sx={{
            padding: '16px',
            position: 'absolute',
            minWidth: '550px',

            top: '10%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Your session has expired!
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Please log in again to continue using the app.
          </Typography>
          <Button sx={{ marginTop: '16px' }} variant="contained" color="primary" onClick={handleCloseInactivityModal}>
            Close
          </Button>
        </Paper>
      </Modal>
    </ThemeProvider>
  );
}

export default App;
